import React, { useLayoutEffect } from "react";
import Portal from "../utils/Portal";

const ModalManager = ({ open, onBackdropClick, children }) => {
	useLayoutEffect(() => {
		const modalRoot = document.getElementById("modal-root");
		manageModalDisplay(modalRoot);

		return () => {
			// setTimeout is necessary to hide/show the modal-root AFTER react has flushed changes to the dom
			setTimeout(() => {
				manageModalDisplay(modalRoot);
			}, 0);
		};
	});

	if (!open) return null;

	return (
		<Portal to={document.getElementById("modal-root")}>
			<div className="modal-backdrop" onClick={onBackdropClick} />
			{children}
		</Portal>
	);
};
export default ModalManager;

// IF no modals THEN hides the modal-root
// ELSE IF there are modals, displays only the last one
function manageModalDisplay(modalRoot) {
	const children = modalRoot.children;

	if (!children.length) {
		modalRoot.style.display = "none";
		document.body.classList.remove("body-disable-scroll");
		return;
	}

	document.body.classList.add("body-disable-scroll");
	modalRoot.style.display = "block";

	// Show only the latest modal
	for (const child of children) {
		if (child.className !== "modal-backdrop") {
			child.style.display = "none";
		}
	}
	const latestModal = children[children.length - 1];
	latestModal.style.display = "";
}
